import { DuplicateSVG } from "@components/svgs";
import { useNotification } from "@hooks/useNotification";
import { IconButton, Tooltip, tooltipClasses, useTheme } from "@mui/material";
import { defaultTo } from "lodash";

export interface CopyButtonProps {
  width?: string;
  height?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  isLoading?: boolean;
  disabled?: boolean;
  tooltipTitle?: string;
  copyValue?: string | null;
  notifyContent?: string;
  [key: string]: any;
}

export const CopyButton = ({
  width = "20px",
  height = "20px",
  isLoading = false,
  disabled = false,
  tooltipTitle,
  copyValue,
  notifyContent,
  ...others
}: CopyButtonProps) => {
  const { palette } = useTheme();
  const { notify } = useNotification();

  return (
    <Tooltip
      title={tooltipTitle}
      enterDelay={0}
      placement="top"
      enterNextDelay={100}
      slotProps={{
        popper: {
          sx: {
            [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
              {
                marginBottom: "5px",
              },
          },
        },
      }}
    >
      <IconButton
        {...others}
        disableRipple
        disabled={disabled}
        sx={{
          width,
          height,
          p: 0,
          backgroundColor: palette.common.white,
          border: `1px solid ${palette.common.black}`,
          boxShadow: "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),3px 4px 5px 0px rgba(0,0,0,0.12)",
          "&:hover": {
            borderColor: palette.primary[800],
            boxShadow: "none",
          },
          "&:active": {
            backgroundColor: palette.primary.dark,
            borderColor: palette.common.black,
            boxShadow: `inset 0 4px 4px ${palette.primary[900]}`,
            "&>svg>path": {
              fill: palette.common.white,
            },
          },
          "&:disabled": {
            border: `1px solid ${palette.text.disabled}`,
            backgroundColor: palette.common.white,
            "&>svg>path": {
              fill: palette.text.disabled,
            },
          },
        }}
        onClick={() => {
          if (!Boolean(copyValue)) return;
          const valueToWrite = defaultTo(copyValue, "");
          navigator.clipboard.writeText(valueToWrite);

          notify(notifyContent, {
            variant: "success",
            close: true,
          });
        }}
      >
        <DuplicateSVG width={10} />
      </IconButton>
    </Tooltip>
  );
};
